// extracted by mini-css-extract-plugin
export default {"login":"saveredirect_login__-NxNg"};